export default "__VITE_ASSET__psZXXVlh__"